define('bootstrap',[
    'jquery-1',
    'imager',
    'istats-1',
    'pubsub'
], function ($, Imager, istats, iframemanager__frame) {

    var imager = new Imager({
        availableWidths: [96, 130, 165, 200, 235, 270, 304, 340, 375, 410, 445, 485, 520, 555, 590, 625]
    });

    return {
        $: $,
        isInTheNewsApp: require.specified('bbcVjAppManager'),
        pubsub: $,
        istats: istats
    };

});

